<template>
  <div class="galeria-widget">
    <div class="mb-3">
      <h4 class="widget-title text-white m-0">
        GALERÍA <span class="text-naranja">FIT BAR</span>
      </h4>
      <p class="widget-desc text-white-50 small mt-2 mb-0">
        Conoce nuestros platillos preparados frescos todos los días en cocina.
      </p>
    </div>

    <div class="galeria-swiper-wrapper rounded-3 overflow-hidden border border-secondary border-opacity-25 shadow-sm">
      <swiper
        :slides-per-view="1"
        :space-between="10"
        :navigation="false"
        :pagination="{ clickable: true }"
        :loop="true"
        :autoplay="{
          delay: 3500,
          disableOnInteraction: false,
        }"
        class="galeria-swiper"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="'slide-' + index">
          <img
            class="img-fluid w-100 galeria-img"
            :src="slide.img"
            :alt="slide.titulo"
            loading="lazy"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, { Autoplay, Pagination } from "swiper";

SwiperCore.use([Autoplay, Pagination]);

export default {
  name: "GaleriaWidget",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      slides: [
        {
          titulo: "Top Sirloin a la Parrilla",
          img: require("@/assets/img/galeria/PLATO_FUERTE_TOP_SIRLOIN.png"),
        },
        {
          titulo: "Salmón a las Finas Hierbas",
          img: require("@/assets/img/galeria/PLATO_FUERTE_SALMÓN_A_LAS_FINAS_HIERBAS.png"),
        },
        {
          titulo: "Matcha Fit Cakes",
          img: require("@/assets/img/galeria/HOTCAKES_MATCHA_FIT_CAKES.png"),
        },
        {
          titulo: "Avena Imperial con Frutos Rojos",
          img: require("@/assets/img/galeria/AVENA_IMPERIAL.png"),
        },
        {
          titulo: "Pechuga de Pollo Marinada",
          img: require("@/assets/img/galeria/PLATO_FUERTE_PECHUGA_DE_POLLO.png"),
        },
        {
          titulo: "Sándwich Mass Pechuga",
          img: require("@/assets/img/galeria/SANDWICH_MASS_PECHUGA.png"),
        },
        {
          titulo: "Omelette con Champiñones",
          img: require("@/assets/img/galeria/OMELETTE_DE_CHAMPIÑONES_CON_QUESO.png"),
        },
        {
          titulo: "Ensalada Fresona",
          img: require("@/assets/img/galeria/ENSALADA_FRESONA.png"),
        },
        {
          titulo: "Batido de Proteína Whey",
          img: require("@/assets/img/galeria/BEBIDA_BATIDO_DE_PROTEÍNA.png"),
        },
      ],
    };
  },
};
</script>

<style scoped>
.widget-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.35rem;
  letter-spacing: 0.02em;
}

.text-naranja {
  color: #fd6f3c !important;
}

.widget-desc {
  font-family: 'Quicksand', sans-serif;
  line-height: 1.5;
}

.galeria-swiper-wrapper {
  background-color: #000000;
}

.galeria-img {
  height: 220px;
  width: 100%;
  object-fit: cover;
  display: block;
}

:deep(.swiper-pagination) {
  bottom: 8px !important;
}

:deep(.swiper-pagination-bullet) {
  background: rgba(255, 255, 255, 0.5) !important;
  opacity: 1;
  width: 8px;
  height: 8px;
  transition: all 0.25s ease;
}

:deep(.swiper-pagination-bullet-active) {
  background: #fd6f3c !important;
  width: 20px;
  border-radius: 6px;
}

@media (max-width: 991px) {
  .galeria-widget {
    text-align: center;
    margin-top: 1rem;
  }
  .galeria-img {
    height: 240px;
  }
}
</style>
